export const AccountArea = () => (
  <div
    className="arx-corporate-header__slot arx-corporate-header__slot--account"
    data-aranox-slot="account"
    aria-label="Área da conta corporativa"
  >
    <span className="arx-corporate-header__avatar" aria-hidden="true">
      AR
    </span>

    <span className="arx-corporate-header__account-copy">
      <span className="arx-corporate-header__label">Conta</span>
      <strong>Corporativa</strong>
    </span>
  </div>
);
